import { useState } from 'react';
import { Apps } from 'constants/global';
import Questions from 'features/bot-builder/components/Common/Questions';
import PostCard from '../components/GetStarted/PostCard';
import PostSection from '../components/GetStarted/PostSection';
import { WelcomeHero } from '../components/GetStarted/WelcomeHero';
import PlatformToggle from '../components/GetStarted/PlatformToggle';
// Mock auth state - replace with actual auth logic

export default function GetStartedPage() {
  const [selectedPlatform, setSelectedPlatform] = useState<'linkedIn' | 'x'>(
    'linkedIn'
  );

  // const [blogInspirations, setBlogInspirations] = useState<>([]);
  // const isAuthenticated = useSelector(
  //   (state: RootState) => state.auth.isAuthenticated
  // );

  // const [loading, setLoading] = useState<boolean>(false);

  return (
    <main className="min-h-[800px] justify-center items-center bg-background-main">
      <div className="rounded-lg rounded-b-none border-b-0 min-h-[640px] pb-16 bg-gradient-light dark:bg-gradient-dark bg-no-repeat bg-cover">
        <div className="mx-auto py-8 lg:py-14 px-4 lg:px-11 max-w-7xl">
          {/* Desktop Layout */}
          <div className="hidden lg:flex justify-between items-start gap-4">
            <WelcomeHero />
            <div className="min-w-0"> {/* This prevents overflow */}
              <PostSection />
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="flex flex-col gap-8 lg:hidden">
            <WelcomeHero />
            
            <PlatformToggle 
              selectedPlatform={selectedPlatform}
              onSelectPlatform={setSelectedPlatform}
            />

            <div className="flex justify-center">
              <PostCard
                value={`?name=${selectedPlatform}`}
                image={
                  selectedPlatform === 'linkedIn'
                    ? '/socialmedialinkedin.png'
                    : '/socialmediax.png'
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Questions appType={Apps.SOCIAL_MEDIA} />

      {/* {isAuthenticated ? (
        <div className="mx-auto rounded-lg rounded-t-none bg-white p-16 max-w-7xl">
          <div className="flex justify-between">
            <h2 className="text-[30px] font-bold mb-6">Your Blogs</h2>
            <Link to="/ai-blog-writer/history">
              <Button variant="customSecondary" className=" text-sm px-8">
                Show all
              </Button>
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogInspirations.length === 0 ? (
              loading ? (
                'Please wait'
              ) : (
                <>
                  <CardSkeleton />
                  <CardSkeleton />
                  <CardSkeleton />
                </>
              )
            ) : (
              blogInspirations.map((blog) => (
                <Link to={`/ai-blog-writer/blog?id=${blog.id}`} key={blog.id}>
                  <BlogCard
                    title={blog?.title}
                    date={blog?.created_at}
                    image={blog?.cover_img_url || '/test.png'}
                  />
                </Link>
              ))
            )}
          </div> */}
      {/* </div>
      ) : (
        <SignUpBanner />
      )} */}
    </main>
  );
}
